import { render, staticRenderFns } from "./FileMetaData.vue?vue&type=template&id=646e6e6c&"
import script from "./FileMetaData.vue?vue&type=script&lang=js&"
export * from "./FileMetaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports